import { ApiResponse, http } from '@config/api';

export interface Language {
	id: string;
	name: string;
	country_code: string;
	image_url: string;
}

export async function getAllLanguages(): Promise<Language[]> {
	const response = await http.get<ApiResponse<Language[]>>('languages', 'list/');

	return response.data.data;
}

export async function getLanguagesByIds(ids: string[]): Promise<Language[]> {
	const response = await http.get<ApiResponse<Language[]>>('languages', 'list/get-by-id/', {
		ids: ids.join(','),
	});

	return response.data.data;
}
